import { formatLithuanianPhone } from '@app/lib/phone/formatLithuanianPhone';

export function formatLithuanianPhoneWithCode(value: string): string {
    const digits = value.replace(/\D/g, '');
    if (!digits) return '';

    const local = digits.startsWith('370') ? digits.slice(3) : digits;
    if (!local) return '';

    return `+370 ${formatLithuanianPhone(local)}`;
}
